export default {
  default: () => import("D:/W-S Projekte/WS_intern/ws-styleguide/layouts/default.vue").then(m => m.default || m)
}